export const REST_ACTIVITY_DURATION_MS = 60_000;
export const REST_ACTIVITIES = ['cooking', 'weapon-care', 'bandaging', 'sit'] as const;
export type RestActivity = typeof REST_ACTIVITIES[number];
export interface RestActivityView { activity: RestActivity; elapsedMs: number; phaseElapsedMs: number; }
/** Presentation epoch belongs to one continuous visible rest, never to an incoming server snapshot. */
export class RestActivityClock {
  private key: string | null = null;
  private startedAt = 0;
  sample(nowMs: number, restKey: string | null): RestActivityView | null {
    if (restKey === null) { this.reset(); return null; }
    if (restKey !== this.key) { this.key = restKey; this.startedAt = nowMs; }
    const elapsedMs = Math.max(0, nowMs - this.startedAt);
    return { activity: REST_ACTIVITIES[Math.floor(elapsedMs / REST_ACTIVITY_DURATION_MS) % REST_ACTIVITIES.length]!,
      elapsedMs, phaseElapsedMs: elapsedMs % REST_ACTIVITY_DURATION_MS };
  }
  reset(): void { this.key = null; this.startedAt = 0; }
}
export function restActivityAssetKey(variant: number, activity: RestActivity): string {
  return activity === 'sit' ? `sit-hero-${variant}` : activity === 'cooking' ? `hero-${variant}` : activity === 'weapon-care' ? `care-hero-${variant}` : `bandage-hero-${variant}`;
}
/** A missing phase retains the accepted whole cooking pose instead of flashing standing artwork. */
export function restActivityFallback<T>(requested: T | null, cooking: T | null): T | null {
  return requested ?? cooking;
}
